export default __webpack_public_path__ + "static/img_interviewee_mkim@2x-2d643317dfac6004664b332817cdbcb1.png";